<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="90px" :inline="true" size="small"
      class="query-form" @submit.native.prevent>
      <el-form-item label="二维码类型">
        <!-- <el-input v-model="queryForm.orgType"></el-input> -->
        <el-select clearable style="width:177px"
          v-model="queryForm.qrcodeType" placeholder="请选择">
          <el-option :label="item.value" :value="item.key" v-for="item,index in productStatusEnumList" :key="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="组织类型">
        <!-- <el-input v-model="queryForm.orgType"></el-input> -->
        <el-select clearable style="width:177px" v-model="queryForm.orgType" placeholder="请选择">
          <el-option label="店铺" :value="1">
          </el-option>
          <el-option label="门店" :value="2">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="组织">
        <!-- <el-input v-model="queryForm.orgId"></el-input> -->
        <GridSelectLi v-if="queryForm.orgType == 1" style="width: 177px" title="选择店铺" labelName="shopName" labelValue="id"
          :value="queryForm.orgId" :limit="1" size="small" :disabled="queryForm.orgType == ''"
          @getValue="getSeachValueShopId" :columns="SHOP_code" :searchs="SHOP_search" dataListUrl="/mall/shop/findList" entityBeanName="mallShop" queryEntityUrl="/mall/shop/get">
        </GridSelectLi>
        <GridSelectLi v-else style="width: 177px" title="选择门店" labelName="storeName" labelValue="id"
          :value="queryForm.orgId" :limit="1" size="small" :disabled="queryForm.orgType == ''"
          @getValue="getSeachValueShopId" :columns="STORE_code" :searchs="STORE_search" dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get">
        </GridSelectLi>
      </el-form-item>
      <el-form-item label="推广人">
        <!-- <el-input  v-model="queryForm.promoterId"></el-input> -->
        <GridSelectLi style="width: 177px" title="选择推广人" labelName="promoterName" labelValue="id"
          :value="queryForm.promoterId" :limit="1" size="small" placeholder="请选择推广人" @getValue="getSeachValuebrandId"
          :columns="PROMOTER_code" :searchs="PROMOTER_search" dataListUrl="/mpp/promoter/findList" entityBeanName="mppPromoter" queryEntityUrl="/mpp/promoter/get">
        </GridSelectLi>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopPayQrcodeList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopPayQrcodes">批量生成</el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="download1">下载</el-button>
          <!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopPayQrcode">新建</el-button> -->
          <el-button type="warning" plain size="small" icon="el-icon-edit" :disabled="multipleSelection.length != 1"
            @click="editShopPayQrcode(null)">修改</el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteShopPayQrcode(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span title="下载模板" class="icon-box" @click="importTemplate">
            <Icon color="#606266">
              <ArrowDown />
            </Icon>
          </span>
          <span class="icon-box" title="导入数据" @click="isImport">
            <Icon color="#606266">
              <ArrowExportUp24Regular />
            </Icon>
          </span>
          <span title="导出数据" class="icon-box" @click="exportShopPayQrcodeList">
            <Icon color="#606266">
              <ArrowDownload24Regular />
            </Icon>
          </span>
          <span class="icon-box" @click="refreshShopPayQrcodeList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="shopPayQrcodeList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="content" label="内容" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="qrcodeType" label="二维码类型" width="180">
          <template slot-scope="scop">
            {{ getEunm(scop.row.qrcodeType) }}
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="orgType" label="组织类型" width="180">
          <template slot-scope="scop">
            {{ getPacketType(scop.row.orgType) }}
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="orgId" label="组织" width="180">
          <template slot-scope="scop">
            <!-- <div v-if="scop.row.orgType"> -->
              <div v-if="scop.row.orgType == 1">{{ scop.row.shop?scop.row.shop.shopName:'--' }}</div>
              <div v-if="scop.row.orgType == 2">{{ scop.row.store?scop.row.store.storeName:'--' }}</div>
            <!-- </div> -->
            <!-- <div v-else>--</div> -->
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="promoterId" label="推广人" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.promoter">
              <div style="text-align: left">姓名：{{ scope.row.promoter.promoterName }}</div>
              <!-- <div style="text-align: left">手机：{{ scope.row.promoter.promoterMobile }}</div> -->
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="status" label="使用状态" width="180">
          <template slot-scope="scop">
            <el-tag v-if="scop.row.status == 1" type="success">正常</el-tag>
            <el-tag v-if="scop.row.status == 0" type="danger">暂停</el-tag>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" width="180">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="300">
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopPayQrcode(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopPayQrcode(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopPayQrcode(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="shopPayQrcodeStates[shopPayQrcodeState]" :visible.sync="showDialog" width="60%"
        @close="closeDialog">
        <div>
          <el-form :model="shopPayQrcode" ref="shopPayQrcodeForm" :rules="rules" label-width="120px" :inline="true"
            size="small">
            <el-form-item label="内容" prop="content">
              <el-input size="small" v-model="shopPayQrcode.content" :disabled="shopPayQrcodeState != 'add'"></el-input>
            </el-form-item>
            <el-form-item label="二维码类型" prop="qrcodeType">
              <el-select clearable style="width:177px" :disabled="shopPayQrcodeState == 'check'"
                v-model="shopPayQrcode.qrcodeType" placeholder="请选择">
                <el-option :label="item.value" :value="item.key" v-for="item,index in productStatusEnumList" :key="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="组织类型" prop="orgType">
              <el-select clearable style="width:177px" :disabled="shopPayQrcodeState == 'check'"
                v-model="shopPayQrcode.orgType" placeholder="请选择">
                <el-option :label="item.value" :value="item.key" v-for="item,index in shopstoreList" :key="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="组织" prop="orgId">
              <GridSelectLi v-if="shopPayQrcode.orgType == 1" style="width: 177px" title="选择店铺" labelName="shopName"
                labelValue="id" :value="shopPayQrcode.orgId" :limit="1" size="small"
                :disabled="shopPayQrcodeState == 'check' || shopPayQrcode.orgType == ''" @getValue="getValueShopId"
                :columns="SHOP_code" :searchs="SHOP_search" dataListUrl="/mall/shop/findList" entityBeanName="mallShop" queryEntityUrl="/mall/shop/get">
              </GridSelectLi>
              <GridSelectLi v-else style="width: 177px" title="选择门店" labelName="storeName" labelValue="id"
                :value="shopPayQrcode.orgId" :limit="1" size="small"
                :disabled="shopPayQrcodeState == 'check' || shopPayQrcode.orgType == ''" @getValue="getValueShopId"
                :columns="STORE_code" :searchs="STORE_search" dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get">
              </GridSelectLi>
            </el-form-item>
            <el-form-item label="推广人" prop="promoterId">
              <GridSelectLi :disabled="shopPayQrcodeState == 'check'" style="width: 177px" title="选择推广人"
                labelName="promoterName" labelValue="id" :value="shopPayQrcode.promoterId" :limit="1"
                size="small" placeholder="请选择推广人" @getValue="getValuebrandId" :columns="PROMOTER_code" :searchs="PROMOTER_search" dataListUrl="/mpp/promoter/findList" entityBeanName="mppPromoter"
                queryEntityUrl="/mpp/promoter/get">
              </GridSelectLi>
            </el-form-item>
            <el-form-item label="使用状态" prop="status">
              <el-radio-group style="width:177px" v-model="shopPayQrcode.status"
                :disabled="shopPayQrcodeState == 'check'">
                <el-radio :label="1" >正常</el-radio>
                <el-radio :label="0" >暂停</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="创建时间" prop="createTime" v-show="shopPayQrcodeState == 'check'">
              <el-input size="small" style="width:177px" v-model="shopPayQrcode.createTime"
                :disabled="shopPayQrcodeState == 'check'"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="shopPayQrcodeState != 'check'">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="批量生成" :visible.sync="showDialogs" width="60%"
        @close="closeDialogs">
        <div>
          <el-form :model="shopPayQrcodes" ref="shopPayQrcodeForms" :rules="ruless" label-width="120px" :inline="true"
            size="small">
            <el-form-item label="二维码类型" prop="qrcodeType">
              <el-select clearable style="width:177px"
                v-model="shopPayQrcodes.qrcodeType" placeholder="请选择">
                <el-option :label="item.value" :value="item.key" v-for="item,index in productStatusEnumList" :key="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="组织类型" prop="orgType">
              <el-select clearable style="width:177px"
                v-model="shopPayQrcodes.orgType" placeholder="请选择">
                <el-option :label="item.value" :value="item.key" v-for="item,index in shopstoreList" :key="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数量" prop="number">
              <el-input style="width:177px" size="small" v-model="shopPayQrcodes.number"></el-input>
            </el-form-item>
            <el-form-item label="设备类型" prop="deviceType">
              <!-- <el-input style="width:177px" size="small" v-model="shopPayQrcodes.deviceType"></el-input> -->
              <el-select clearable style="width:177px"
                v-model="shopPayQrcodes.deviceType" placeholder="请选择">
                <el-option :label="item.value" :value="item.key" v-for="item,index in deviceTypeList" :key="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialogs">关闭</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { STORE, STORE_SEARCH, SHOP, SHOP_SEARCH, PROMOTER, PROMOTER_SEARCH } from '@/utils/constant';

export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    GridSelectLi
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        this.resetShopPayQrcodeList();
        this.getShopPayQrcodeList(this.queryForm);
        this.$emit('resetCheckState');
      } else if (val == 'reset') {
        this.resetShopPayQrcodeList();
        this.getShopPayQrcodeList();
        this.$emit('resetCheckState');
      }
    },
    'queryForm.orgType': {
      handler(newval, oleval) {
        this.queryForm.orgId = '';
      },
    },
    'shopPayQrcode.orgType': {
      handler(newval, oleval) {
        if (this.shopPayQrcodeState == 'check' || this.shopPayQrcodeState == 'edit') {
          return
        }
        this.shopPayQrcode.orgId = '';
      },
    }
  },
  data() {
    return {
      STORE_code: STORE,
      STORE_search: STORE_SEARCH,
      SHOP_code: SHOP,
      SHOP_search: SHOP_SEARCH,
      PROMOTER_code: PROMOTER,
      PROMOTER_search: PROMOTER_SEARCH,
      queryForm: {
        id: '', //ID
        content: '', //内容
        orgType: '', //组织类型
        orgId: '', //组织ID
        promoterId: '', //推广人ID
        status: '', //二维码状态 1正常使用 0暂停使用
        createTime: '', //
      },
      open: false,
      loading: false,
      shopstoreList: [],
      showDialog: false,
      showDialogs: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      shopPayQrcodeState: 'add',
      shopPayQrcodeStates: {
        add: '新建二维码',
        check: '查看二维码',
        edit: '修改二维码'
      },

      multipleSelection: [],
      shopPayQrcodeList: [],
      shopPayQrcode: {
        id: '', //ID
        content: '', //内容
        orgType: '', //组织类型
        orgId: '', //组织ID
        promoterId: '', //推广人ID
        status: 1, //二维码状态 1正常使用 0暂停使用
        createTime: '', //
      },
      shopPayQrcodes: {
        number: '',
        orgType: '', //组织类型
        orgId: '', //组织ID
        deviceType:""
      },
      btnLoading: false,
      productStatusEnumList:[],
      deviceTypeList:[],
      rules: {
        id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
        orgType: [{ required: true, message: '组织类型不能为空', trigger: 'blur' }],
        orgId: [{ required: true, message: '组织ID不能为空', trigger: 'blur' }],
        promoterId: [{ required: true, message: '推广人ID不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '二维码状态 1正常使用 0暂停使用不能为空', trigger: 'blur' }],
      },
      ruless: {
        orgType: [{ required: true, message: '组织类型不能为空', trigger: 'blur' }],
        number: [{ required: true, message: '组织ID不能为空', trigger: 'blur' }],
        qrcodeType: [{ required: true, message: '二维码类型不能为空', trigger: 'blur' }],
        deviceType: [{ required: true, message: '设备类型不能为空', trigger: 'blur' }],
      }
    };
  },
  created() {
    this.getShopPayQrcodeList();
    this.getShopStoreList();
    this.getProductStatusEnum();
    this.getProductStatusEnum1()
  },
  methods: {
    download1(){
      post('/shop/qrcode/download',{}).then((res) => {
        if (res.success) {
          console.log(res)
          window.open(res.url)
        }else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      })
    },
    getEunm(key){
      for (const iterator of this.productStatusEnumList) {
        if(iterator.key == key){
          return iterator.value
        }
      }
    },
    // 获取设备类型枚举
    getProductStatusEnum1() {
      get('/mpp/utils/getEnum', {
        enumType: 'device_type',
      }).then((res) => {
        if (res.success) {
          this.deviceTypeList = res.enumList
          console.log(this.deviceTypeList)
        }
      })
    },
    // 获取商品状态枚举
    getProductStatusEnum() {
      get('/mpp/utils/getEnum', {
        enumType: 'qrcode_type',
      }).then((res) => {
        if (res.success) {
          this.productStatusEnumList = res.enumList
          console.log(this.productStatusEnumList)
        }
      })
    },
    getShopStoreList() {
      get('/mpp/utils/getEnum', { enumType: 'qrcode_org_type' }).then((res) => {
        if (res.success && res.code == 200) {
          this.shopstoreList = res.enumList;
        }
      });
    },
    getPacketType(packetType) {
      for (const index in this.shopstoreList) {
        if (this.shopstoreList[index].key == packetType) {
          return this.shopstoreList[index].value;
        }
      }
    },
    // 店铺
    getValueShopId(value) {
      this.shopPayQrcode.orgId = value
    },
    getValueShopIds(value) {
      this.shopPayQrcodes.orgId = value
    },
    getSeachValueShopId(value) {
      this.queryForm.orgId = value
    },
    // 选择推广人
    getValuebrandId(value) {
      this.shopPayQrcode.promoterId = value;
    },
    getSeachValuebrandId(value) {
      this.queryForm.promoterId = value;
    },
    search() {
      this.isSearch = !this.isSearch;
    },
    resetShopPayQrcodeList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.shopPayQrcodeList = [];
    },
    resetDialog() {
      this.shopPayQrcodeState = 'add';
      this.showDialog = false;
      this.queryForm = {
        id: '', //ID
        content: '', //内容
        orgType: '', //组织类型
        orgId: '', //组织ID
        promoterId: '', //推广人ID
        status: '', //二维码状态 1正常使用 0暂停使用
        createTime: '', //
      };
      this.getShopPayQrcodeList();
    },
    resetDialogs() {
      this.showDialogs = false;
      this.shopPayQrcodes = {
        number: '',
        orgType: '', //组织类型
        orgId: '', //组织ID
        deviceType:""
      };
      this.getShopPayQrcodeList();
    },
    closeDialog() {
      this.showDialog = false
      this.open = false
      this.shopPayQrcode = {
        id: '', //ID
        content: '', //内容
        orgType: '', //组织类型
        orgId: '', //组织ID
        promoterId: '', //推广人ID
        status: 1, //二维码状态 1正常使用 0暂停使用
        createTime: '', //
      };
    },
    closeDialogs() {
      this.showDialogs = false
      this.shopPayQrcodes = {
        number: '',
        orgType: '', //组织类型
        orgId: '', //组织ID
        deviceType:""
      };
    },
    submitForms() {
      this.$refs.shopPayQrcodeForms.validate((valid) => {
        if (valid) {
          console.log(this.shopPayQrcodes)
          this.resetShopPayQrcodeList();
          this.resetDialogs();
        }
      })
    },
    submitForm() {
      if (this.shopPayQrcodeState == 'add') {
        this.$refs.shopPayQrcodeForms.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/shop/qrcode/addBatch`, { ...this.shopPayQrcodes }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetShopPayQrcodeList();
                this.resetDialogs();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.shopPayQrcodeState == 'edit') {
        this.$refs.shopPayQrcodeForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            delete this.shopPayQrcode.promoter
            delete this.shopPayQrcode.shop
            delete this.shopPayQrcode.store
            post(`/shop/qrcode/edit`, { ...this.shopPayQrcode }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetShopPayQrcodeList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addShopPayQrcode() {
      this.showDialog = true;
      this.shopPayQrcodeState = 'add';
    },
    addShopPayQrcodes() {
      this.showDialogs = true;
      this.shopPayQrcodeState = 'add';
    },
    checkShopPayQrcode(shopPayQrcodeId) {
      console.log(shopPayQrcodeId);
      this.currentShopPayQrcodeId = shopPayQrcodeId;

      this.getShopPayQrcodeById();
      this.showDialog = true;
      this.shopPayQrcodeState = 'check';
    },
    editShopPayQrcode(shopPayQrcodeId) {
      console.log('shopPayQrcode', shopPayQrcodeId);
      if (shopPayQrcodeId) {
        this.currentShopPayQrcodeId = shopPayQrcodeId;
        this.getShopPayQrcodeById();
      } else {
        this.shopPayQrcode = { ...this.shopPayQrcode, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.shopPayQrcodeState = 'edit';
    },
    deleteShopPayQrcode(shopPayQrcodeId) {
      let ids = '';
      if (shopPayQrcodeId) {
        ids = shopPayQrcodeId;
      } else {
        ids = this.multipleSelection.map((shopPayQrcode) => shopPayQrcode.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      }).then(() => {
          deleteFun(`/shop/qrcode/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetShopPayQrcodeList();
              this.getShopPayQrcodeList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshShopPayQrcodeList() {
      this.resetShopPayQrcodeList();
      this.getShopPayQrcodeList();
    },
    getShopPayQrcodeList(query = {}) {
      this.loading = true;
      get(`/shop/qrcode/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.shopPayQrcodeList = res.page.list;
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getShopPayQrcodeById() {
      get(`/shop/qrcode/get`, { id: this.currentShopPayQrcodeId }).then((res) => {
        if (res.success) {
          this.shopPayQrcode = { ...this.shopPayQrcode, ...res.shopPayQrcode };
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportShopPayQrcodeList() {
      //this.btnLoading = true;
      exprotExcel(`/shop/qrcode/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/shop/qrcode/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/shop/qrcode/importData`, formData);
      this.refreshShopPayQrcodeList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getShopPayQrcodeList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getShopPayQrcodeList();
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}
</style>